import { BaseTable } from "./BaseTable";
import { RowActionLink, rowActionIcons } from "./rowActions";

export function VideosDeletedTable() {
	return (
		<BaseTable
			preset="deleted"
			actions={{
				id: "actions",
				key: "actions",
				label: "Actions",
				header: () => "Actions",
				cell: (value, row) => (
					<div className="actionsCell">
						<RowActionLink icon={rowActionIcons.view} label="View page" to={`/video-uploads/${row.id}/video`} />
					</div>
				),
			}}
		/>
	);
}
